import React from "react";
import "../styles/Thankyou.css";

const Thankyou = () => {
  const handleView = () => {
    // placeholder for action (navigate, open modal, download receipt...)
    alert("View submission details — implement action here.");
  };

  return (
    <div className="thankyou-wrapper" role="region" aria-labelledby="thankyou-title">
      <div className="thankyou-box" tabIndex={-1}>
        <h1 id="thankyou-title" className="thankyou-title"> Thank You!</h1>

        <p className="thankyou-sub">
          Your Excel has been successfully downloaded.
          <br />
          We appreciate your time and contribution.
        </p>

        <div className="thankyou-actions" role="group" aria-label="submission actions">
          <button
            className="back-button-primary"
             onClick={() => window.location.replace("/fipiawards/admin")}
            aria-label="View submission details"
          >
             Back to Home
          </button>

        
        </div>

        <div className="color-glow" aria-hidden="true" />
      </div>
    </div>
  );
};

export default Thankyou;
